import {
  Button,
  ERROR_MESSAGES,
  FormInput,
  FormInputMoney,
  MASKS,
  PATTERNS,
} from "@farzoom/common-ui-components";
import { Checkbox, Col, Divider, Empty, Row, Space, Typography } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import classNames from "classnames";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useStyles } from "./styles";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { BankSearch } from "@app/common-ui-components";

type CustomerBankAccounts = {
  prefix: string;
};

const { Text } = Typography;

const SPACE_SIZE = 6;

const ACCOUNT_MODEL = {
  accountNumber: "",
  bank: { name: "", bic: "", corrNumber: "" },
  cardFile2: false,
  cardFile2Amount: 0,
};

export const CustomerBankAccounts = ({
  prefix,
}: CustomerBankAccounts) => {
  const {control, getValues, watch, setValue, register} = useFormContext();
  const classes = useStyles();
  const {
    fields: accounts,
    prepend,
    remove,
  } = useFieldArray({
    control,
    name: `${prefix}.bankAccounts` as "customerBankAccounts.bankAccounts",
  });

  const initialValues = getValues(`${prefix}.bankAccounts` as "customerBankAccounts.bankAccounts");
  const bankAccounts = watch(`${prefix}.bankAccounts` as "customerBankAccounts.bankAccounts");

  const onAddAccount = () => {
    prepend(ACCOUNT_MODEL);
  };

  const onCardFile2Change = (idx: number) => {
    return (e: CheckboxChangeEvent) => {
      setValue(`${prefix}.bankAccounts.${idx}.cardFile2`, e.target.checked);
      if (!e.target.checked) {
        setValue(`${prefix}.bankAccounts.${idx}.cardFile2Amount`, 0);
      }
    };
  };

  return (
    <fieldset>
      <div className={classNames(classes.title, classes.titleWithAction)}>
        <span>Банковские счета</span>
        {/* {!config.readonly && ( */}
          <Button type="outlined" iconName="add" title="Добавить счет" onClick={onAddAccount} />
        {/* )} */}
      </div>
      <div className={classes.wrapper}>
        {accounts.length === 0 && (
          <Empty description="Банковские счета отсутствуют">
            <Button className={classes.emptyAddBtn} text="Добавить" onClick={onAddAccount} />
          </Empty>
        )}
        {accounts.map((account, idx) => (
          <>
            <Row key={account.id + idx} align="top" gutter={8}>
              <Col span={10}>
                <VerticalSpace size={SPACE_SIZE}>
                  <BankSearch
                    label="Банк"
                    className={classes.formItem}
                    prefix={`${prefix}.bankAccounts.${idx}.bank`}
                    setValue={setValue}
                    control={control}
                    getVisibleFieldName={(prfx) => `${prfx}.name`}
                    hiddenFieldNames={[
                      { target: "bic", source: (opt) => opt?.data?.bic },
                      { target: "corrNumber", source: (opt) => opt?.data?.correspondent_account },
                    ]}
                    type="name"
                    required
                    controlled
                  />
                  <Space>
                    <Text type="secondary" className={classes.formItemInfo}>
                      БИК: {bankAccounts[idx]?.bank?.bic}
                    </Text>
                    <Text type="secondary" className={classes.formItemInfo}>
                      к/с: {bankAccounts[idx]?.bank?.corrNumber}
                    </Text>
                  </Space>
                </VerticalSpace>
              </Col>
              <Col span={7}>
                <VerticalSpace size={SPACE_SIZE}>
                  <FormInput
                    label="Номер р/с"
                    className={classes.formItem}
                    name={`${prefix}.bankAccounts.${idx}.accountNumber`}
                    control={control}
                    setValue={setValue}
                    defaultValue={initialValues[idx]?.accountNumber}
                    mask={MASKS.bankAccount}
                    pattern={{
                      value: PATTERNS.bankAccount,
                      message: ERROR_MESSAGES.bankAccount,
                    }}
                    required
                    // disabled={config.readonly}
                  />
                  <Checkbox
                    {...register(`${prefix}.bankAccounts.${idx}.cardFile2`)}
                    onChange={onCardFile2Change(idx)}
                    checked={getValues(`${prefix}.bankAccounts.${idx}.cardFile2`)}
                  >
                    Картотека №2
                  </Checkbox>
                </VerticalSpace>
              </Col>
              <Col span={6}>
                <FormInputMoney
                  name={`${prefix}.bankAccounts.${idx}.cardFile2Amount`}
                  label="Сумма задолженности"
                  className={classes.formItem}
                  setValue={setValue}
                  control={control}
                  defaultValue={initialValues[idx]?.cardFile2Amount}
                  controls={false}
                  disabled={!bankAccounts[idx].cardFile2}
                  maxLength={25}
                />
              </Col>
              {/* {screenSize.l && ( */}
                <Col span={1} className={classes.flexCenterCol}>
                  {/* {!config.readonly && ( */}
                    <Button
                      type="outlined"
                      iconName="remove"
                      onClick={() => remove(idx)}
                      title="Удалить счет"
                    />
                   {/* )} */}
                </Col>
              {/* )} */}
            </Row>
            {/* {!screenSize.l && ( */}
              {/* <Button
                className={classes.removeBtn}
                type="primary"
                onClick={() => remove(idx)}
                text="Удалить счет"
              /> */}
            {/* )} */}
            {accounts.length > 1 && <Divider />}
          </>
        ))}
      </div>
    </fieldset>
  );
};
